import { forwardRef } from 'react'
import { tv, type VariantProps } from 'tailwind-variants'

const spinnerRecipe = tv({
  base: 'inline-block rounded-full border-2 border-solid animate-spin border-b-transparent border-l-transparent',
  variants: {
    size: {
      sm: 'w-4 h-4 border-[1.5px]',
      md: 'w-6 h-6 border-2',
    },
    colorPalette: {
      gray: 'border-t-zinc-600 border-r-zinc-600',
    },
  },
  defaultVariants: {
    size: 'md',
    colorPalette: 'gray',
  },
})

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof spinnerRecipe> {
  label?: string
}

export const Spinner = forwardRef<HTMLDivElement, SpinnerProps>((props, ref) => {
  const { label = 'Loading...', size, colorPalette, className, ...rest } = props

  return (
    <div ref={ref} className={spinnerRecipe({ size, colorPalette, className })} {...rest}>
      {label && <span className='sr-only'>{label}</span>}
    </div>
  )
})

Spinner.displayName = 'Spinner'
